import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import Table from "../dashboard/components/Table/Table";

// data
import mock from "../dashboard/mock";

const datatableData = [
  ["مهدی رمضانی", "senior", "تهران", "FE"],
  ["سعید پور حسینی", "junior", "بندر انزلی", "BE"],
  ["نازنین حسینی", "Mid Level", "کرج", "BE"],
  ["مریم مومنی", "senior", "کرج", "FE"],
  ["زیبا نژاد جانانه", "senior", "کرج", "BE"],
  ["مهسا فرجاد", "junior", "رشت", "FE"],
  ["محمد معانی", "junior", "رشت", "FE"],
  ["مهران مخبری", "Mid Level", "قزوین", "FE"],
  ["الهام بابایی", "Mid Level", "قزوین", "FE"],
  ["نسرین زاغری", "Mid Level", "قزوین", "FE"],
  ["فهیمه مافی", "Mid Level", "تهران", "FE"],
  ["علی فیلی", "Mid Level", "تهران", "FE"],
  ["علی حافظی", "Mid Level", "تهران", "FE"],
  ["سیاوش سیدی", "Mid Level", "تهران", "FE"],
  ["مهران جنیدی", "Mid Level", "تهران", "BE"],
  ["مجید مظفری", "Mid Level", "تهران", "BE"],
  ["کیارش مدرسی", "Mid Level", "تهران", "BE"],
];

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
}));

export default function Tables() {
  const classes = useStyles();
  return (
    <>
      <PageTitle title="جداول" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="لیست کارمندان"
            data={datatableData}
            columns={["نام", "سطح ارشدیت", "شهر", "جایگاه"]}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Widget
            title="لیست مشتریان"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableOverflow}
          >
            <Table data={mock.table} />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
